import { useContext } from "react";
import { useTranslation } from "react-i18next";

import { ContractContext } from "../../../../providers/contract";
import { IShippingContact } from "../../../../setup/api/services/contract/models";
import styles from "./styles.module.scss";

const ContactRow = ({
  titleKey,
  contact,
}: {
  titleKey: string;
  contact: IShippingContact;
}) => {
  const { t } = useTranslation();
  return (
    <div className={styles.contact_row}>
      <p className={styles.contact_title}>{t(titleKey)}</p>
      {contact.name && (
        <p className={styles.contact_line}>
          <span className={styles.contact_label}>{t("lbl_name")}:</span>
          <span className={styles.contact_value}>{contact.name}</span>
        </p>
      )}
      {contact.mobile && (
        <p className={styles.contact_line}>
          <span className={styles.contact_label}>{t("lbl_mobile")}:</span>
          <span className={styles.contact_value}>{contact.mobile}</span>
        </p>
      )}
    </div>
  );
};

const ShippingContactsInfo = () => {
  const { contract } = useContext(ContractContext);
  const { t } = useTranslation();

  const buyerShippingContact = contract?.metaData?.buyerShippingContact;
  const sellerShippingContact = contract?.metaData?.sellerShippingContact;

  if (!buyerShippingContact && !sellerShippingContact) return null;

  return (
    <div className={styles.info_card}>
      <p className={styles.info_label}>{t("lbl_shipping_contacts")}</p>
      {buyerShippingContact && (
        <ContactRow
          titleKey="lbl_buyer_shipping_contact"
          contact={buyerShippingContact}
        />
      )}
      {sellerShippingContact && (
        <ContactRow
          titleKey="lbl_seller_shipping_contact"
          contact={sellerShippingContact}
        />
      )}
    </div>
  );
};

export default ShippingContactsInfo;
